import { FC } from "react";
import SourceDataItemValue, { ISourceDataItemValueProps } from "./SourceDataItemValue";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppSettings } from "@/AppSettings";
import { Box } from "@mui/material";

const SourceDataItemCheckboxValue: FC<ISourceDataItemValueProps> = ({
    itemData,
    hideBorderStyles,
    hideStyles
}) => {
    const isYes = itemData?.sourceDataItem?.value === '1';

    return (
        <SourceDataItemValue
            hideBorderStyles={hideBorderStyles}
            hideStyles={hideStyles}
            startAdornment={
                <FontAwesomeIcon 
                    size="lg"
                    icon={isYes ? AppSettings.icons.itemValueCheckboxChecked : AppSettings.icons.itemValueCheckboxUnchecked} 
                />
            }
        >
            {itemData?.value}
        </SourceDataItemValue>
    );
};

export default SourceDataItemCheckboxValue;